import styled from 'styled-components';


export const QuizIntro = styled.section`
  margin-top: 2rem;
`;

export const QuestionSection = styled.section`
  display: flex;
  justify-content: space-between;

  width: 42rem;
  height: 4rem;

  margin: 2rem 0;

  label {
    color: #555;
  }

  input, select {
    border: 1px solid lightgray;
    width: 20rem;
    height: 4rem;
    padding: 0.25rem 0.5rem;
    background: #f3f3f3;
    border-radius: 0.25rem;
  }

  @media (max-width: 550px) {
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 8rem;

    label {
      font-size: 2rem;
      margin-bottom: 1rem;
    }
    input, select {
      height: 2.7rem;
    }
  }
  @media (min-width: 550px) {
    label {
      font-size: 2rem;
      margin-bottom: 1rem;
    }
    input, select {
      height: 3rem;
    }

  }
`;
